/**
 * 
 */
import { OrganizationShort } from '@n3/ng-api-common';
import { ClassifierShort } from '@n3/ng-api-common';
import { PersonShort } from '@n3/ng-api-common';
import { Address } from '@n3/ng-api-common';
import { Contact } from '@n3/ng-api-common';
import { OrganizationMeta } from './organizationMeta.model';
export class Organization extends OrganizationShort {
    public _isEmpty: boolean; /*указывает на то пустой ли объект*/
    public okpo: string; /*ОКПО*/
    public okato: string; /*ОКATO*/
    public kpp: string; /*КПП*/
    public oktmo: ClassifierShort; /**/
    public okogu: string; /*ОКОГУ*/
    public owner: PersonShort; /**/
    public head: PersonShort; /**/
    public type_of_ownership: ClassifierShort; /**/
    public founders_type: ClassifierShort; /**/
    public status: ClassifierShort; /**/
    public address: Address; /**/
    public district: ClassifierShort; /**/
    public region: ClassifierShort; /**/
    public country: ClassifierShort; /**/
    public okopf: ClassifierShort; /**/
    public okfs: ClassifierShort; /**/
    public okved: ClassifierShort[]; /*Коды оквед*/
    public contacts: Contact[]; /*Контактная информация*/
    public meta: OrganizationMeta; /**/

    constructor(json?: any) {
        if (json === void 0 || json === null) {
            json = {};
        }
        super(json);

        this.okpo = json.okpo || null;
        this.okato = json.okato || null;
        this.kpp = json.kpp || null;
        this.oktmo = new ClassifierShort(json.oktmo);
        this.okogu = json.okogu || null;
        this.owner = new PersonShort(json.owner);
        this.head = new PersonShort(json.head);
        this.type_of_ownership = new ClassifierShort(json.type_of_ownership);
        this.founders_type = new ClassifierShort(json.founders_type);
        this.status = new ClassifierShort(json.status);
        this.address = new Address(json.address);
        this.district = new ClassifierShort(json.district);
        this.region = new ClassifierShort(json.region);
        this.country = new ClassifierShort(json.country);
        this.okopf = new ClassifierShort(json.okopf);
        this.okfs = new ClassifierShort(json.okfs);
        this.okved = [];
        if (json.okved) {
          for (const i in json.okved) {
            if ( json.okved.hasOwnProperty( i ) ) {
                this.okved.push(new ClassifierShort(json.okved[i]));
            }
          }
        }
        this.contacts = [];
        if (json.contacts) {
          for (const i in json.contacts) {
            if ( json.contacts.hasOwnProperty( i ) ) {
                this.contacts.push(new Contact(json.contacts[i]));
            }
          }
        }
        this.meta = new OrganizationMeta(json.meta);
        this._isEmpty = this.isEmpty(this);
    }
}
